module.exports = __webpack_public_path__ + "media/images/logos/Durham-University-7e39cbd15113a30c8a2945cb38fcb2bf.svg";